<template>
  <div class="shoppe">
    <div class="effective-time">
      <span class="effective-time-title">生效时间：</span>
      <template v-if="editTimeStatus">
        <el-time-picker style="width: 120px" size="small" v-model="showTime" :editable="false" :clearable="false" format="HH:mm" value-format="HH:mm" :picker-options="{ format: 'HH:mm' }" placeholder="选择时间"></el-time-picker>
        <el-button type="text" class="ml10" :disabled="disabledEdit" @click="submitTime">保存</el-button>
        <el-button type="text" @click="editTimeStatus = false">取消</el-button>
      </template>
      <template v-else>
        <span class="effective-time-value"><i class="el-icon-time"></i> {{ showTime }}</span>
        <el-button type="text" class="ml10" :disabled="disabledEdit" @click="clickEditTime">修改</el-button>
      </template>
    </div>

    <div style="width: 800px">
      <div class="toolbar">
        <span><span class="red">*</span>生效时间前30min，后2小时不允许修改</span>
        <div>
          <el-button type="text" :disabled="disabledEdit" v-if="!editRateStatus" @click="clickEditRate">编辑</el-button>
          <el-button type="text" :disabled="disabledEdit" v-if="editRateStatus" @click="submitRate">保存</el-button>
          <el-button type="text" v-if="editRateStatus" @click="editRateStatus = false">取消</el-button>
        </div>
      </div>
      <el-table border :data="tableData" :row-class-name="rowClassName">
        <el-table-column prop="fromCountry" label="原始币种" align="center"></el-table-column>
        <el-table-column prop="toCountry" label="转到币种" align="center"></el-table-column>
        <el-table-column label="当前汇率" align="center">
          <template slot-scope="scope">
            <span class="num">{{ scope.row.currentRate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="待生效汇率" align="center">
          <template slot-scope="scope">
            <span v-if="!editRateStatus" class="num">{{ scope.row.waitEffectRate }}</span>
            <el-input-number v-else style="width: 100%;" v-model="scope.row.editWaitEffectRate" :min="0" :controls="false"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
  </div>
</template>

<script>
import {
  getPriceUnitList,
  updatePriceUnit,
  updateWaitEffectTime,
  getWaitEffectTime
} from "./api";
import utils from '../../../../utils/util';

export default {
  data() {
    return {
      showTime: '',
      time: null,
      disabledEdit: true,
      editTimeStatus: false,
      editRateStatus: false,
      tableData: [],
    };
  },
  mounted() {
    this.getTableData();
    this.getWaitEffectTime();
  },
  methods: {
    getWaitEffectTime() {
      getWaitEffectTime().then(res => {
        if (res.data && res.data.data) {
          this.time = res.data.data;
          this.checkTime();
          this.showTime = utils.dateFormat(new Date(this.time), 'hh:mm');
        }
      })
    },
    checkTime() {
      const nowDate = new Date();
      const nowTime = nowDate.getTime();
      const currDate = new Date(this.time);
      currDate.setFullYear(nowDate.getFullYear());
      currDate.setMonth(nowDate.getMonth());
      currDate.setDate(nowDate.getDate());
      const currTime = currDate.getTime();
      const minTime = currTime - 1000 * 60 * 30;
      const maxTime = currTime + 1000 * 60 * 60 * 2;
      if (nowTime >= minTime && nowTime <= maxTime) {
        this.disabledEdit = true;
        return false;
      }
      this.disabledEdit = false;
      return true;
    },
    clickEditTime() {
      if (this.checkTime()) {
        this.editTimeStatus = true;
      }
    },
    submitTime() {
      // 后端以日期来存储，这里使用2020-12-03这天的某个时分
      const dateStr = '2020-12-03 ' + this.showTime + ':00';
      const date = new Date(dateStr);
      updateWaitEffectTime({
        waitEffectTime: date.getTime()
      }).then(res => {
        if (res.data.success) {
          this.editTimeStatus = false;
          this.$message.success('保存成功');
          this.getWaitEffectTime();
        } else {
          this.$message.error(res.data.message || '保存失败');
        }
      })
    },
    search() {
      this.getTableData();
    },
    reset() {
      this.queryForm.code = null;
      this.getTableData();
    },
    getTableData() {
      getPriceUnitList(this.queryForm).then(res => {
        this.tableData = res.data.data.map((item) => {
          item.editWaitEffectRate = item.waitEffectRate || undefined;
          return item;
        });
      })
    },
    showForm() {
      this.form.fromCountry = '';
      this.form.currentRate = '';
      this.dialogVisible = true;
    },
    clickEditRate() {
      if (this.checkTime()) {
        this.tableData = this.tableData.map((item) => {
          item.editWaitEffectRate = item.waitEffectRate || undefined;
          return item;
        });
        this.editRateStatus = true;
      }
    },
    submitRate() {
      const data = {
        productExchangeRateVO: []
      }
      let errType = 0;
      this.tableData.forEach(item => {
        if (item.editWaitEffectRate == 0) {
          errType = 1;
        }
        if (item.editWaitEffectRate && (item.editWaitEffectRate > item.currentRate * 1.05 || item.editWaitEffectRate < item.currentRate * 0.95)) {
          errType = 2;
        }
        data.productExchangeRateVO.push({
          productExchangeRateId: item.productExchangeRateId,
          currentRate: item.editWaitEffectRate,
        })
      })
      if (errType === 1) {
        this.$message.error('待生效汇率不能为0，请检查');
        return;
      }
      if (errType === 2) {
        this.$message.error('待生效汇率和当前汇率相差不能超过5%，请检查');
        return;
      }
      updatePriceUnit(data).then(res => {
        if (res.data.success) {
          this.editRateStatus = false;
          this.$message.success('保存成功');
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '保存失败');
        }
      })
    },
    rowClassName({row, rowIndex}) {
      if (row.editWaitEffectRate != null && (row.editWaitEffectRate > row.currentRate * 1.05 || row.editWaitEffectRate < row.currentRate * 0.95)) {
        return 'error-row';
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.red {
  color: #F56C6C;
}
.num {
  font-family: Menlo, Consolas, 'Courier New';
}
.effective-time-title {
  font-size: 16px;
}
.effective-time-value {
  font-size: 16px;
  font-weight: bold;
}
.shoppe {
  padding: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.ml10 {
  margin-left: 10px;
}
</style>
<style>
.el-table .error-row {
  background: #F56C6C;
}
</style>